import React from 'react'
import config from '../../../config.json'
import OverlaySpinner from '../../overlay/presentational/OverlaySpinner'
import requestStatus from '../../../constants/requestStatus'
import OverlayText from '../../overlay/presentational/OverlayText'
import actionTypes from '../../../actions/actionTypes'
import OverlayNonSiOhhh from '../../overlay/presentational/OverlayNonSiOhhh'
import NewsletterCampaignStructure from './NewsletterCampaignStructure'
import WrapperPageEdit from '../../WrapperPage/present/WrapperPageEdit'
import NewsletterPreviewButtons from './NewsletterPreviewButtons'
import { OVERLAY_NEWSLETTER_SEND, OVERLAY_NEWSLETTER_YES_NO } from '../../../constants/overlayTypes'

            
const PageNewsletterCampaign = ({
    pageName, 
    weeks, 
    currentWeek, 
    cinemaId,
    campaignId, 
    campaign,
    hasSendNewsletter, 
    selectedItems, 
    hasChanges,
    filteredItemsData,
    canEditProgram,
    canEditNewsletter,
    displayDropzones, 
    uiRequestOverlay, 
    updateWeek, 
    addItem,
    reorderItem,
    deleteItem,
    deleteItemComplete,
    requestUpdateData,
    requestSendNewsletter, 
    sendNewsletter, 
    cancelRequestSendNewsletter, 
    sendStatus, 
    sendError
}) => {
    if(!campaign) {
        return ''
    }

    const { pk, structure } = campaign
    
    let overlay=''

    if(uiRequestOverlay.requestType === actionTypes.NEWSLETTER_SEND_REQUEST && uiRequestOverlay.overlayType === OVERLAY_NEWSLETTER_YES_NO) {
        overlay = <OverlayNonSiOhhh
            titleTransId={hasSendNewsletter ? 'print_newsletter_send_newsletter_now' : 'print_newsletter_create_newsletter_now'}
            text={sendError ? sendError.message : ''}
            nonButtonTextTransId="cancel_button"
            nonOnClickButton={() => cancelRequestSendNewsletter()}
            siButtonTextTransId={hasSendNewsletter ? 'print_newsletter_send' : 'print_newsletter_create'}
            siOnClickButton={() => sendNewsletter(campaignId, selectedItems)} //ToDo: CHeck selectedItems 
        />
    } else if (requestStatus.REQUEST_PENDING === sendStatus && uiRequestOverlay.overlayType === OVERLAY_NEWSLETTER_SEND) {
        overlay = <OverlaySpinner transId={hasSendNewsletter ? "print_newsletter_are_sent" : "print_newsletter_are_created"} />
    } else if(requestStatus.REQUEST_SUCCESS === sendStatus && uiRequestOverlay.overlayType === OVERLAY_NEWSLETTER_SEND) {
        overlay = <OverlayText
            titleTransId={hasSendNewsletter ? 'print_newsletter_have_been_sent' : 'print_newsletter_have_been_created'} 
            text=''
            buttonTextTransId='button_close'
            onClickButton={cancelRequestSendNewsletter}
        />
    } else if(requestStatus.REQUEST_PENDING === sendStatus) {
        overlay = <OverlaySpinner transId='data_is_loading' />

    } else if(requestStatus.REQUEST_ERROR === sendStatus) {
        overlay = <OverlayText
            titleTransId="print_newsletter_an_error_has_occurred"
            text={sendError ? sendError.message : ''}
            buttonTextTransId='button_close'
            onClickButton={cancelRequestSendNewsletter}
        />
    }

    return (
        <WrapperPageEdit 
            pageTitle={pageName} 
            closePagePath={config.routes.newsletter.path} 
            overlay={overlay}
            canEdit={true}
            clickEdit={`${config.routes.newsletter.path}/campaign/${campaignId}/settings`}
        >
            <div className="newsletter-page-campaign program-page print-page program-page-sorting-movies site-content">
                <div className="selections-item">
                    <NewsletterCampaignStructure
                        cinemaId={cinemaId}
                        campaignId={pk}
                        structure={structure}
                        weeks={weeks}
                        currentWeek={currentWeek}
                        selectedItems={selectedItems}
                        filteredItemsData={filteredItemsData}
                        displayDropzones={displayDropzones}
                        canEditProgram={canEditProgram}
                        canEditNewsletter={canEditNewsletter}
                        updateWeek={updateWeek}
                        addItem={addItem}
                        reorderItem={reorderItem}
                        deleteItem={deleteItem}
                        deleteItemComplete={deleteItemComplete}
                    />
                </div>

                <NewsletterPreviewButtons
                    hasChanges={hasChanges}
                    campaignId={campaignId}
                    hasSendNewsletter={hasSendNewsletter}
                    selectedItems={selectedItems}
                    requestUpdateData={requestUpdateData}
                    requestSendNewsletter={requestSendNewsletter}
                />
            </div>
        </WrapperPageEdit>
    )
}

export default PageNewsletterCampaign